import {Component, DoCheck, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {BaseDetailComponent} from '../../common/BaseDetailComponent';
import {E015User} from '../../../Models/E015User/E015User';
import {NgForm} from "@angular/forms";

@Component({
  selector: 'app-e015-user-detail',
  templateUrl: './e015UserDetail.component.html',
  styleUrls: ['./e015UserDetail.component.css']
})
export class E015UserDetailComponent extends BaseDetailComponent implements DoCheck {

  @Input('selectedRow') selectedRow?: any;
  @Input('editMode') editMode?: boolean;

  @Output() close = new EventEmitter();
  @Output() validForm = new EventEmitter<boolean>();

  @ViewChild('updateForm') updateForm!: NgForm;

  ngDoCheck(): void {
    this.validForm.emit(!this.updateForm?.invalid);
  }

  dataDetail?: E015User;

}
